module.exports = __webpack_public_path__ + "img/users.bfd1a54d.svg";